import React from "react";
import { Icon } from "../Procedures/ProcUi";
import { KB_DOMAINS } from "./kbHelpers";

// Fenêtre « Nouveau dossier de recherche » (kb.jsx du prototype).
export const KbNewModal = ({ init, onClose, onCreate }) => {
  const [title, setTitle] = React.useState(init || "");
  const [domain, setDomain] = React.useState("fiscal");
  const [tags, setTags] = React.useState("");
  const ok = title.trim().length > 2;
  const go = () =>
    ok && onCreate({ title: title.trim(), domain, tags: tags.split(",").map((t) => t.trim()).filter(Boolean) });

  return (
    <div className="scrim" onClick={onClose}>
      <div className="modal pr-new-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <div className="icon-square"><Icon name="folder" size={22} /></div>
          <div>
            <h2>Nouveau dossier de recherche</h2>
            <div className="meta">
              <span style={{ fontSize: 12.5, color: "var(--ink-3)" }}>Un dossier par thème de recherche</span>
            </div>
          </div>
          <div className="actions">
            <button className="x-btn" onClick={onClose}><Icon name="x" size={16} /></button>
          </div>
        </div>
        <div className="modal-body pr-new-body">
          <label className="pr-f-lab">Thème <span className="req">*</span></label>
          <input
            autoFocus
            className="pr-f-in pr-f-big"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Ex. : Abattement ZFANG chez les agriculteurs"
            onKeyDown={(e) => e.key === "Enter" && go()}
          />
          <label className="pr-f-lab">Domaine</label>
          <div className="kb-chips kb-chips-m">
            {KB_DOMAINS.map((x) => (
              <button key={x.id} className={domain === x.id ? "on" : ""} onClick={() => setDomain(x.id)}>
                <span className="kb-dot" style={{ background: x.color }}></span>
                {x.name}
              </button>
            ))}
          </div>
          <label className="pr-f-lab">Mots-clés</label>
          <input className="pr-f-in" value={tags} onChange={(e) => setTags(e.target.value)} placeholder="Séparés par des virgules" />
        </div>
        <div className="pr-new-foot">
          <button className="btn" onClick={onClose}>Annuler</button>
          <button className="btn primary" disabled={!ok} onClick={go}>Créer le dossier</button>
        </div>
      </div>
    </div>
  );
};
